import React, { PureComponent } from 'react';
import axios from 'axios';
import { Row, Col, Button } from 'react-bootstrap';
import Layout from '../../components/complex/layout';
import InputComponent from '../../components/baseComponents/input';
import appConstant from '../../../constants/app';

const token = localStorage.getItem('token');

class ChangePassword extends PureComponent {
  state = {
    currentPassword: '',
    newPassword: '',
    confirmedPassword: '',
    errorMessage: null,
    successMessage: null,
  }

  refFields = {}

  handleInputChange = (val, name) => {
    this.setState({[name]: val});
  }

  isValidForm = () => {
    if (this.state.newPassword !== this.state.confirmedPassword) {
      this.setState({
        errorMessage: "Error in password confirmation",
        successMessage: "",
      });
      return;
    }

    return Object.keys(this.refFields)
      .map(field => this.refFields[field] && this.refFields[field].validate())
      .reduce((sum, validField) => validField != null && sum + (!validField ? 1 : 0), 0) === 0;
  }

  onFormSubmit = (e) => {
    const {
      currentPassword,
      newPassword,
      confirmedPassword,
    } = this.state;

    e.preventDefault() // Stop form submit

    if(!this.isValidForm()) return false;

    axios({
      method: 'post',
      url: `${appConstant.API_URL}/user/reset-password?access_token=${token}`,
      data: {
        current_password: currentPassword,
        new_password: newPassword,
        confirmed_password: confirmedPassword,
      },
    })
    .then(res => {
      if (res.data['errors'] !== undefined) {
        this.setState({
          errorMessage: res.data.errors,
          successMessage: '',
        })
      } else if (res.data['message'] !== undefined) {
        this.setState({
          errorMessage: '',
          successMessage: 'Your password has been changed succesfully',
          currentPassword: '',
          newPassword: '',
          confirmedPassword: '',
        })
      } else {
        this.setState({
          errorMessage: 'Error',
          successMessage: '',
        })
      }
    }).catch(err => {
      console.log(err);
    });
  }

  render() {
    const {
      currentPassword,
      newPassword,
      confirmedPassword,
    } = this.state;

    return (
      <Layout>
        <h2 className="tittle-change-password">Change my password</h2>
        <Row className="change-password-body">
          <Col sm={8}>
            <form onSubmit={this.onFormSubmit}>
              <Row>
                <Col sm={12}>
                  <label>Current password</label>
                  <InputComponent className="current-password"
                    value={currentPassword}
                    ref={(input) => { this.refFields.currentPassword = input; }}
                    inputGroup="currentPassword"
                    validationRules="required"
                    customErrorMessage="Required field"
                    placeholder='Current password'
                    classes='form-control'
                    onChange={this.handleInputChange}
                    type="password"
                  />
                </Col>
              </Row>
              <Row>
                <Col  className="new-password" sm={12}>
                  <label>New password</label>
                  <InputComponent
                    value={newPassword}
                    ref={(input) => { this.refFields.newPassword = input; }}
                    inputGroup="newPassword"
                    validationRules="required|password"
                    customErrorMessage="Required field"
                    placeholder='New password'
                    classes='form-control'
                    onChange={this.handleInputChange}
                    type="password"
                  />
                </Col>
              </Row>
              <Row>
                <Col className="confirm-password" sm={12}>
                  <label>Confirm password</label>
                  <InputComponent
                    value={confirmedPassword}
                    ref={(input) => { this.refFields.confirmedPassword = input; }}
                    inputGroup="confirmedPassword"
                    validationRules="required"
                    customErrorMessage="Required field"
                    placeholder='Confirm password'
                    classes='form-control'
                    onChange={this.handleInputChange}
                    type="password"
                  />
                </Col>
              </Row>
              {this.state.errorMessage && <div className="error-message">{this.state.errorMessage}</div>}
              {this.state.successMessage && <div style={{color: 'green'}}>{this.state.successMessage}</div>}
              <Row
                className="buttons-row header-edit-btns">
                <Col sm={12}>
                  <Button
                    type="submit"
                    className="accept-btn"
                  >
                    Change password
                  </Button>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default ChangePassword;


// WEBPACK FOOTER //
// ./src/app/screens/profile/changePassword.js